<template>
  <div class="hp-picker">
    <div class="hp-picker__head">
      <span class="hp-picker__title">محصولات انتخاب‌شده ({{ value.length }})</span>
    </div>

    <ul class="hp-picker__list">
      <li v-for="(pid, i) in value" :key="pid" class="hp-picker__item">
        <img v-if="info(pid).image" :src="info(pid).image" class="hp-picker__img" alt="">
        <span v-else class="hp-picker__img hp-picker__img--ph"></span>
        <span class="hp-picker__name">{{ info(pid).name || ('محصول #' + pid) }}</span>
        <div class="hp-picker__ops">
          <button type="button" class="hp-picker__btn" :disabled="i === 0" @click="move(i, -1)">▲</button>
          <button type="button" class="hp-picker__btn" :disabled="i === value.length - 1" @click="move(i, 1)">▼</button>
          <button type="button" class="hp-picker__btn hp-picker__btn--danger" @click="remove(i)">✕</button>
        </div>
      </li>
      <li v-if="!value.length" class="hp-picker__empty">محصولی انتخاب نشده است</li>
    </ul>

    <input
      v-model="q"
      class="hp-picker__search"
      type="text"
      placeholder="جستجوی محصول (نام یا کد)..."
      @input="onSearch"
    >

    <ul v-if="results.length" class="hp-picker__results">
      <li
        v-for="p in results"
        :key="p.id"
        class="hp-picker__item hp-picker__item--click"
        @click="add(p)"
      >
        <img v-if="p.image" :src="p.image" class="hp-picker__img" alt="">
        <span v-else class="hp-picker__img hp-picker__img--ph"></span>
        <span class="hp-picker__name">{{ p.name }}</span>
        <span v-if="value.indexOf(p.id) !== -1" class="hp-picker__tag">انتخاب‌شده</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { searchProducts } from './hpApi'

const nameCache = {}

export default {
  name: 'HpProductPicker',
  props: { value: { type: Array, default: function () { return [] } } },
  data() {
    return { q: '', results: [], timer: null, tick: 0 }
  },
  mounted() {
    if (this.value.some((id) => !nameCache[id])) this.fetch('', 500, true)
  },
  methods: {
    info(id) {
      // eslint-disable-next-line no-unused-expressions
      this.tick
      return nameCache[id] || {}
    },
    onSearch() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.q.trim().length < 2) { this.results = []; return }
        this.fetch(this.q.trim(), 20, false)
      }, 350)
    },
    fetch(q, perPage, silent) {
      searchProducts(q, perPage).then((res) => {
        const items = ((res.data && res.data.items) || []).map((p) => ({
          id: p.id,
          name: p.name,
          image: p.gallery && p.gallery[0] ? p.gallery[0].image : ''
        }))
        items.forEach((p) => { nameCache[p.id] = p })
        this.tick++
        if (!silent) this.results = items
      }).catch(() => {})
    },
    emit(list) {
      this.$emit('input', list)
    },
    add(p) {
      if (this.value.indexOf(p.id) !== -1) return
      this.emit(this.value.concat([p.id]))
    },
    remove(i) {
      const l = this.value.slice()
      l.splice(i, 1)
      this.emit(l)
    },
    move(i, d) {
      const l = this.value.slice()
      const t = l[i]
      l[i] = l[i + d]
      l[i + d] = t
      this.emit(l)
    }
  }
}
</script>

<style scoped>
.hp-picker {
  margin-top: 4px;
}

.hp-picker__head {
  margin-bottom: 8px;
}

.hp-picker__title {
  font-size: 12px;
  font-weight: 800;
  color: var(--panel-text, #111827);
}

.hp-picker__list,
.hp-picker__results {
  list-style: none;
  margin: 0 0 10px;
  padding: 0;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 10px;
  overflow: hidden;
  background: var(--panel-surface, #fff);
}

.hp-picker__results {
  max-height: 260px;
  overflow-y: auto;
}

.hp-picker__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--panel-border, #e5e7eb);
}

.hp-picker__item:last-child {
  border-bottom: 0;
}

.hp-picker__item--click {
  cursor: pointer;
}

.hp-picker__item--click:hover {
  background: var(--panel-surface-2, #f8fafc);
}

.hp-picker__empty {
  padding: 12px 10px;
  font-size: 12px;
  color: var(--panel-muted, #6b7280);
}

.hp-picker__img {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid var(--panel-border, #e5e7eb);
  flex-shrink: 0;
}

.hp-picker__img--ph {
  display: inline-block;
  background: var(--panel-surface-2, #f1f5f9);
}

.hp-picker__name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: var(--panel-text, #111827);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hp-picker__ops {
  display: flex;
  gap: 4px;
}

.hp-picker__btn {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid var(--panel-border, #e5e7eb);
  background: var(--panel-surface, #fff);
  color: var(--panel-muted, #6b7280);
  cursor: pointer;
  font-size: 12px;
  padding: 0;
}

.hp-picker__btn:disabled {
  opacity: .4;
  cursor: not-allowed;
}

.hp-picker__btn--danger {
  color: #dc2626;
  border-color: rgba(220, 38, 38, .25);
}

.hp-picker__tag {
  font-size: 11px;
  font-weight: 700;
  color: #15803d;
  background: rgba(22, 163, 74, .12);
  border-radius: 99px;
  padding: 2px 8px;
}

.hp-picker__search {
  width: 100%;
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 10px;
  background: var(--panel-surface, #fff);
  color: var(--panel-text, #111827);
  font-family: inherit;
  font-size: 13px;
  outline: none;
  box-shadow: none;
  margin-bottom: 8px;
}

.hp-picker__search:focus {
  border-color: #111111;
}
</style>
